import React from 'react';
import MyOrders from '../../components/feature/my-orders';
import withLayout from '../../components/layout/index';
const Orders = () => {
    return (
        <MyOrders />
    );
};

export default withLayout(Orders, true, true, { search: false, wisList: false, notification: false, title: 'MY WINS' });
